var mobileConsentQuery = window.matchMedia('(max-width: 767.98px)');
var consentNoticeShown = false;

function consentCopy() {
    var lang = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase();

    if (lang.indexOf('en') === 0) {
        return {
            accept: 'Accept all',
            close: 'Close',
            choose: 'Let me choose',
        };
    }

    return {
        accept: 'Zaakceptuj wszystkie',
        close: 'Zamknij',
        choose: 'Pozwól mi wybrać',
    };
}

function setButtonLabel(button, text) {
    if (button && button.textContent !== text) {
        button.textContent = text;
    }
}

function declineConsent(root) {
    var decline = root.querySelector('.cn-decline, .cm-btn-decline');

    if (decline) {
        decline.click();
    }
}

function addDismissButton(container) {
    if (!container || container.querySelector('.cookie-consent-dismiss, .cm-modal .hide')) {
        return;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cookie-consent-dismiss';
    button.setAttribute('aria-label', consentCopy().close);
    button.textContent = '\u00D7';
    button.addEventListener('click', function (event) {
        event.preventDefault();
        declineConsent(container);
    });

    var host = container.querySelector('.cn-body, .cm-header') || container;
    host.appendChild(button);
}

function enhanceNotice(notice) {
    if (!notice || notice.classList.contains('cookie-notice-hidden')) {
        return;
    }

    consentNoticeShown = true;
    setButtonLabel(notice.querySelector('.cn-buttons .cm-btn-success'), consentCopy().accept);
    addDismissButton(notice);
}

function enhanceModal(modal) {
    if (consentNoticeShown) {
        modal.classList.remove('cookie-consent-compact');
        return;
    }

    if (modal.dataset.consentExpanded === 'true') {
        modal.classList.remove('cookie-consent-compact');
        addDismissButton(modal);
        return;
    }

    modal.classList.add('cookie-consent-compact');
    setButtonLabel(modal.querySelector('.cm-btn-accept-all'), consentCopy().accept);

    if (!modal.querySelector('.cookie-consent-choose')) {
        var choose = document.createElement('button');
        choose.type = 'button';
        choose.className = 'cookie-consent-choose';
        choose.textContent = consentCopy().choose;
        choose.addEventListener('click', function () {
            modal.dataset.consentExpanded = 'true';
            modal.classList.remove('cookie-consent-compact');
            choose.remove();
        });

        var footer = modal.querySelector('.cm-footer-buttons');
        if (footer) {
            footer.insertBefore(choose, footer.firstChild);
        }
    }

    addDismissButton(modal);
}

function enhanceCookieConsent() {
    if (!mobileConsentQuery.matches) {
        return;
    }

    enhanceNotice(document.getElementById('klaro-cookie-notice'));

    var modal = document.querySelector('.klaro .cookie-modal');
    if (modal) {
        enhanceModal(modal);
    }
}

function watchCookieConsent() {
    enhanceCookieConsent();

    var root = document.getElementById('klaro') || document.body;
    if (!root || root.dataset.consentWatch === 'true') {
        return;
    }

    root.dataset.consentWatch = 'true';

    var observer = new MutationObserver(function () {
        enhanceCookieConsent();
    });

    observer.observe(root, { childList: true, subtree: true });
    mobileConsentQuery.addEventListener('change', enhanceCookieConsent);
}

// Footer "Ustawienia cookies" (#204): opens the same settings as the plugin's floating
// button, which is hidden on phones so it doesn't cover content.
document.addEventListener('click', function (event) {
    if (!event.target.closest('.js-cookie-settings')) {
        return;
    }

    var settingsButton = document.querySelector('.ct-consent-settings-button');
    if (settingsButton) {
        settingsButton.click();
    }
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCookieConsent);
} else {
    watchCookieConsent();
}
